import { createTheme } from "@mui/material/styles";

const customTheme = createTheme({
  typography: {
    fontFamily: [
      'Titillium Web',
      'sans-serif',
    ].join(','),
  },
  palette: {
    primary: {
      light: '#773dbd',
      main: '#221349',
      dark: '#190e34',
      contrastText: '#fff',
    },
    secondary: {
      light: '#f5d335',
      main: '#f5b335',
      dark: '#eb9e0c',
      contrastText: '#000',
    },
    complementary: {
      light: '#ff8896',
      main: '#ff5569',
      dark: '#ff223c',
      contrastText: '#fff',
    },
    purpleCold: {
      light: '#e1d7f0',
      main: '#ccbce9',
      dark: '#835dc9',
      contrastText: '#000',
    },
    grape: {
      light: '#9f74d2',
      main: '#773dbd',
      dark: '#532a83',
      contrastText: '#fff',
    },
    purple: {
      light: '#9f74d2',
      main: '#773dbd',
      dark: '#532a83',
      contrastText: '#fff',
    }
  },
})

export default customTheme;
